import React from "react";
import { useFormContext } from "react-hook-form";
import { Info } from "react-feather";
import Input from "Components/UI/Input";
import ImageUploader from "Components/UI/ImageUploder";
import ImageCropper from "Components/UI/Image/ImageCropper";
const PassportDetails = () => {
  const {
    register,
    formState: { errors },
    watch,
    setValue,
    clearErrors,
    trigger
  } = useFormContext();

  const setfrontimageBase64Value = (value) => {
    setValue("documentImageDetails[0].frontimage", value);
    clearErrors("documentImageDetails[0].frontimage");
    trigger("documentImageDetails[0].frontimage")
  };

  const setbackimageBase64Value = (value) => {
    setValue("documentImageDetails[0].backimage", value);
    clearErrors("documentImageDetails[0].backimage");
    trigger("documentImageDetails[0].backimage")
  };

  return (
    <>
      <div>
        <div className="addproduct-icon list icon">
          <h5>
            <Info className="add-info" />
            <span>Passport Information</span>
          </h5>
        </div>

        <div className="row mb-3">
          <div className="col-md-6 col-lg-6 col-sm-6 mb-2">
            <Input
              name="documentImageDetails[0].passportNumber"
              type="text"
              placeholder=""
              className={`form-control ${
                errors.documentImageDetails?.[0]?.passportNumber
                  ? "is-invalid"
                  : ""
              }`}
              label="Passport Number"
              labelClassName="form-label"
              required={false}
              requiredMessage="Passport is required"
              defaultValue={watch("documentImageDetails[0].passportNumber")}
            />
          </div>

          <div className="col-md-6 col-lg-6 col-sm-6 mb-2">
            <Input
              name="documentImageDetails[0].issuedDate"
              type="date"
              placeholder=""
              className={`form-control ${
                errors.documentImageDetails?.[0]?.issuedDate ? "is-invalid" : ""
              }`}
              label="Passport Issued Date"
              labelClassName="form-label"
              required={false}
              requiredMessage="Passport Issued Date is required"
              dateFormat="YYYY-MM-DD"
              defaultValue={watch("documentImageDetails[0].passportNumber")}
            />
          </div>

          <div className="col-md-6 col-lg-6 col-sm-6 mb-2">
            <Input
              name="documentImageDetails[0].expiryDate"
              type="date"
              placeholder=""
              className={`form-control ${
                errors.documentImageDetails?.[0]?.expiryDate ? "is-invalid" : ""
              }`}
              label="Expiry Date"
              labelClassName="form-label"
              required={false}
              requiredMessage="Issue Date is required"
              dateFormat="YYYY-MM-DD"
              defaultValue={watch("documentImageDetails[0].expiryDate")}
            />
          </div>

          <div className="col-md-6 col-lg-6 col-sm-6 mb-2">
            <Input
              name="documentImageDetails[0].issuedPlace"
              type="text"
              placeholder=""
              className={`form-control ${
                errors.documentImageDetails?.[0]?.issuedPlace
                  ? "is-invalid"
                  : ""
              }`}
              label="Passport Issue Place"
              labelClassName="form-label"
              required={false}
              requiredMessage="Passport Issue Place is required"
              defaultValue={watch("documentImageDetails[0].issuedPlace")}
            />
          </div>
        </div>
      </div>

      <div>
        <div className="addproduct-icon list icon">
          <h5>
            <Info className="add-info" />
            <span>ID Images</span>
          </h5>
        </div>
        <div className="row mb-3">
          <div className="col-md-6">
            <label className="form-label">Front Image</label>
            <div>
              <ImageCropper
                base64Value={watch("documentImageDetails[0].frontimage")}
                setBase64Value={setfrontimageBase64Value}
              />
              {errors?.documentImageDetails?.[0]?.frontimage && (
                <div className="text-danger mt-2">
                  {errors.documentImageDetails?.[0].frontimage.message}
                </div>
              )}
            </div>
          </div>

          <div className="col-md-6">
            <label className="form-label">Back Image</label>

            <ImageCropper
              base64Value={watch("documentImageDetails[0].backimage")}
              setBase64Value={setbackimageBase64Value}
            />
            {errors?.documentImageDetails?.[0]?.backimage && (
              <div className="text-danger mt-2">
                {errors.documentImageDetails?.[0].backimage.message}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default PassportDetails;
